import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageSEO({ title, description, canonicalUrl, ogImage, ogType = 'website', jsonLd }: {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  jsonLd?: Record<string, unknown>;
}) {
  const location = useLocation();

  useEffect(() => {
    const currentUrl = canonicalUrl || `https://heiliaoshipin.com${location.pathname}`;
    const pageTitle = title || '黑料视频-明星艺人黑料视频大全';
    const pageDescription = description || '黑料视频收录娱乐圈最新最全明星黑料视频，涵盖艺人丑闻、翻车现场、争议事件等真实影像记录。';

    document.title = pageTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', pageDescription);
    setMeta('og:title', pageTitle, true);
    setMeta('og:description', pageDescription, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', currentUrl, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', pageTitle);
    setMeta('twitter:description', pageDescription);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', currentUrl);

    if (jsonLd) {
      let script = document.querySelector('script[data-ld="page"]');
      if (!script) {
        script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.setAttribute('data-ld', 'page');
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    }
  }, [title, description, canonicalUrl, ogImage, ogType, jsonLd, location.pathname]);

  return null;
}